import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import emailjs from 'emailjs-com';
import { useState } from 'react';
import JsonData from '../data/data.json';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles((theme) => ({
    root: {
        '& label.MuiFormLabel-root.MuiInputLabel-shrink': {
            color: theme.palette.secondary.main,
            background: 'rgba(0,0,0,.8)',
            padding: '4px 8px',
            borderRadius: 20,
            transform: 'translate(10px, -10px) scale(0.75)',
            '&.Mui-error': { color: theme.palette.error.main, }
        },
        '& .MuiTextField-root': {
            width: '100%',
            '& .MuiInputBase-root': {
                background: 'white',
                '& textarea': { padding: 0 }
            },
            '& .MuiInputBase-root.Mui-disabled': { background: 'rgba(144, 144, 144, 1)' },
            '& .MuiFormHelperText-root:not(.Mui-error)': { color: '#97de1a' }
        },
        '& .MuiFormControl-root': {
            '& .MuiInputBase-input': { padding: '12px' },
            '& .MuiFormHelperText-root:not(.Mui-error)': { color: '#97de1a' },
            '& .MuiInputLabel-outlined:not(.Mui-focused):not(.MuiFormLabel-filled)': {
                transform: 'translate(14px, 14px) scale(1)'
            }
        },
        '& .MuiAutocomplete-root': {
            '& .MuiInputBase-input': {
                padding: '4px!important'
            }
        },
        '& .MuiFormGroup-root + .MuiFormHelperText-root': {
            marginTop: -12
        },
    },
    contactInfoH3: {
        color: theme.palette.white.main,
        marginTop: 94,
        marginBottom: 25,
        paddingBottom: 20
    },
    textField: {
        '& label.Mui-focused': { // Focused color
            color: theme.palette.secondary.dark,
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: theme.palette.secondary.dark,
        },
        '& .MuiOutlinedInput-root': { // Default border color
            '& fieldset': {
                // borderColor: 'red',
            },
            '&:hover fieldset': { // Hover color
                borderColor: theme.palette.secondary.main,
            },
            '&.Mui-focused fieldset': {
                borderColor: theme.palette.secondary.dark,
            },
        }
    }
}));

const initialState = {
    from_name: '',
    reply_to: '',
    message: '',
};

export const Contact = (props) => {
    const [{ from_name, reply_to, message }, setState] = useState(initialState);
    const classes = useStyles();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({ ...prevState, [name]: value }));
    };
    const clearState = () => setState({ ...initialState });

    const handleSubmit = (e) => {
        e.preventDefault();
        let { SERVICE_ID, TEMPLATE_ID, USER_ID } = JsonData.Contact.credentials;

        emailjs.send(SERVICE_ID, TEMPLATE_ID, { to_name: 'AFPAuto.com', from_name, message, reply_to, }, USER_ID)
            .then(
                (result) => {
                    console.log(result.text);
                    clearState();
                },
                (error) => {
                    console.log(error.text);
                }
            );
    };
    return (
        <div id='contact'>
            <Container maxWidth="lg">
                <Grid container justifyContent="space-between">
                    <Grid item xs={12} md={8}>
                        <div className='section-title'>
                            <h2>Get In Touch</h2>
                            <p>
                                Please fill out the form below to send us an email and we will
                                get back to you as soon as possible.
                            </p>
                        </div>

                        <Grid container className={classes.root}>
                            <Grid item xs={12}>
                                <form
                                    className={classes.textField}
                                    name='sentMessage'
                                    validate="validate"
                                    onSubmit={handleSubmit}>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                type='text'
                                                id='from_name'
                                                name='from_name'
                                                className='form-control'
                                                placeholder='Name'
                                                variant="outlined"
                                                required
                                                onChange={handleChange}
                                                value={from_name}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <TextField
                                                type='email'
                                                id='reply_to'
                                                name='reply_to'
                                                className='form-control'
                                                placeholder='Email'
                                                variant="outlined"
                                                required
                                                onChange={handleChange}
                                                value={reply_to}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextField
                                                name='message'
                                                id='message'
                                                className='form-control'
                                                placeholder='Message'
                                                required
                                                minRows={4}
                                                onChange={handleChange}
                                                variant="outlined"
                                                multiline
                                                value={message}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <div id='success'></div>
                                            <button type='submit' className='btn btn-custom btn-lg'>
                                                Send Message
                                            </button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <div className='contact-item'>
                            <h3 className={classes.contactInfoH3}>Contact Info</h3>
                            <p>
                                <span><i className='fa fa-map-marker'></i> Address</span>
                                {props.data ? props.data.address : 'loading'}
                            </p>
                        </div>
                        <div className='contact-item'>
                            <p>
                                <span><i className='fa fa-phone'></i> Phone</span>{' '}
                                {props.data ? props.data.phone : 'loading'}
                            </p>
                        </div>
                        <div className='contact-item'>
                            <p>
                                <span><i className='fa fa-envelope-o'></i> Email</span>{' '}
                                {props.data ? props.data.email : 'loading'}
                            </p>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};
